export default "__VITE_ASSET__1bb850d0__"